import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Pillars } from "@/components/Pillars";
import { Manifesto } from "@/components/Manifesto";
import { WeeklyColumn } from "@/components/WeeklyColumn";
import { Vaarta } from "@/components/Vaarta";
import { JoinForm } from "@/components/JoinForm";
import { Footer } from "@/components/Footer";
import ArticlePage from "@/components/ArticlePage";
import CategoryPage from "@/pages/CategoryPage";
import AdminGate from "@/pages/AdminGate";

const Home = () => (
  <main className="bg-samatva-cream text-samatva-ink font-sans">
    <div className="noise-overlay" />
    <Navbar />
    <Hero />
    <EditorialMarquee />
    <WeeklyColumn />
    <Pillars />
    <Manifesto />
    <Vaarta />
    <JoinForm />
    <Footer />
  </main>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/column/:slug" element={<ArticlePage />} />
          <Route path="/stories/:categoryId" element={<CategoryPage />} />
          <Route path="/admin" element={<AdminGate />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" richColors />
    </div>
  );
}

export default App;
